import React from 'react';
import { componentRegistry } from '../data/componentRegistry';
import ComponentCard from '../components/ui/ComponentCard';
import SEO from '../components/SEO';

const AllComponentsPage = () => {
    // Convert registry object to array
    const components = Object.entries(componentRegistry).map(([slug, data]) => ({
        slug,
        ...data
    }));

    return (
        <div className="min-h-screen bg-black pt-16">
            <SEO
                title="All Components"
                description="Explore our complete collection of premium React components with stunning animations and effects."
                url="/components"
            />

            <main className="container mx-auto px-4 py-12 md:py-16 lg:py-20">
                {/* Header */}
                <div className="text-center mb-12 md:mb-16">
                    <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 md:mb-6">
                        Component Gallery
                    </h1>
                    <p className="text-gray-400 text-lg md:text-xl max-w-2xl mx-auto">
                        Explore our collection of {components.length} premium React components.
                        Click any card to view details and get the code.
                    </p>
                </div>

                {/* Component Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 md:gap-8">
                    {components.map(({ slug, title, description, component }) => (
                        <ComponentCard
                            key={slug}
                            slug={slug}
                            title={title}
                            description={description}
                            component={component}
                        />
                    ))}
                </div>

                {/* Footer CTA */}
                <div className="mt-16 md:mt-20 text-center">
                    <div className="inline-block p-8 rounded-2xl bg-gradient-to-br from-purple-900/20 to-pink-900/20 border border-white/10">
                        <h2 className="text-2xl md:text-3xl font-bold text-white mb-3">
                            Ready to Build Something Amazing?
                        </h2>
                        <p className="text-gray-400 mb-6">
                            All components are production-ready and fully customizable.
                        </p>
                        <a
                            href="#"
                            className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-purple-500 to-pink-500 text-white rounded-lg font-medium hover:shadow-lg hover:shadow-purple-500/50 transition-all duration-300"
                        >
                            Get Started
                            <svg
                                className="w-5 h-5"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M13 7l5 5m0 0l-5 5m5-5H6"
                                />
                            </svg>
                        </a>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default AllComponentsPage;
